import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import * as styles from './RatingStars.module.scss';
import { ratingStarsPropTypes } from '@Theme/natucare/components/RatingStars/RatingStarsPropTypes';
const RatingStars = ({
  ratingScore,
  ratingCount
}) => {
  if (!ratingScore && ratingCount) {
    return null;
  }
  const fullStars = Math.floor(ratingScore);
  const halfStar = (ratingScore - fullStars) * 100 / 50;
  let emptyStars = 5 - ratingScore;
  if (halfStar < 1 && halfStar > 0) {
    emptyStars = emptyStars + 1;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootStarsWrapper
  }, /*#__PURE__*/React.createElement("svg", {
    display: "none",
    id: "editor-icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "icon-star"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118l11.547-1.2L16.026,0.6L20.388,10.918z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "half-star"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccc",
    points: "32,12.118 20.389,10.918 16.026,0.6 16,0.66 16,25.325 16.021,25.312 25.914,31.4 23.266,19.867"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "11.547,10.918 0,12.118 8.822,19.867 6.127,31.4 16,25.325 16,0.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "empty-star"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118l11.547-1.2L16.026,0.6L20.388,10.918z"
  })))), fullStars && _toConsumableArray(Array(fullStars)).map((_, index) => /*#__PURE__*/React.createElement("svg", {
    key: index,
    className: styles.rootIcon,
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-star"
  }))), halfStar >= 1 && /*#__PURE__*/React.createElement("svg", {
    className: styles.rootIcon,
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#half-star"
  })), emptyStars > 1 && _toConsumableArray(Array(Math.floor(emptyStars))).map((_, index) => /*#__PURE__*/React.createElement("svg", {
    key: index,
    className: styles.rootIcon,
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-star"
  })))), /*#__PURE__*/React.createElement("span", {
    className: styles.rootStarsCount
  }, "(", ratingCount, ")"));
};
export default RatingStars;